import { Button } from "@/components/ui/button";
import { Phone, Calculator, Calendar } from "lucide-react";
import { track } from "@/lib/analytics";
import { useIsMobile } from "@/hooks/use-mobile";

export function MobileCTABar() {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border">
      <div className="container px-4 py-3">
        <div className="grid grid-cols-3 gap-2">
          <a
            href="tel:0617105786"
            onClick={() => track("mobile_cta_phone")}
          >
            <Button
              variant="outline"
              size="lg"
              className="w-full flex flex-col items-center gap-1 h-auto py-3 min-h-[60px] text-primary border-primary hover:bg-primary/10"
            >
              <Phone className="h-5 w-5" />
              <span className="text-sm font-medium">Bel Nu</span>
            </Button>
          </a>
          
          <Button
            variant="outline"
            size="lg"
            className="w-full flex flex-col items-center gap-1 h-auto py-3 min-h-[60px] border-secondary text-secondary hover:bg-secondary/10"
            onClick={() => {
              track("mobile_cta_calculator");
              document.getElementById("instant-quote")?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            <Calculator className="h-5 w-5" />
            <span className="text-sm font-medium">Bereken</span>
          </Button>
          
          <Button
            variant="default"
            size="lg"
            className="w-full flex flex-col items-center gap-1 h-auto py-3 min-h-[60px] bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg"
            onClick={() => {
              track("mobile_cta_calendly");
              (window as any).Calendly?.initPopupWidget?.({
                url: 'https://calendly.com/sol-vi/new-meeting?primary_color=ff7800',
                pageSettings: {
                  backgroundColor: 'ffffff',
                  hideEventTypeDetails: false,
                  hideLandingPageDetails: false,
                  primaryColor: 'ff7800',
                  textColor: '4d5055'
                }
              });
            }}
          >
            <Calendar className="h-5 w-5" />
            <span className="text-sm font-medium">Afspraak</span>
          </Button>
        </div>
      </div>
    </div>
  );
}